/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1TagId202,
  PutApiV1TagId400,
  PutApiV1TagId401,
  PutApiV1TagId404,
  PutApiV1TagId500,
  PutApiV1TagIdMutationRequest,
  PutApiV1TagIdMutationResponse,
  PutApiV1TagIdPathParams,
} from "../../types/tagRegistroController/PutApiV1TagId.ts";
import { tagViewModelSchema } from "../tagViewModelSchema.ts";
import { updateTagRequestViewModelSchema } from "../updateTagRequestViewModelSchema.ts";

export const putApiV1TagIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1TagIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1TagId202Schema = z.lazy(
  () => tagViewModelSchema,
) as unknown as ToZod<PutApiV1TagId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1TagId400Schema =
  z.any() as unknown as ToZod<PutApiV1TagId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1TagId401Schema =
  z.any() as unknown as ToZod<PutApiV1TagId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1TagId404Schema =
  z.any() as unknown as ToZod<PutApiV1TagId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1TagId500Schema =
  z.any() as unknown as ToZod<PutApiV1TagId500>;

export const putApiV1TagIdMutationRequestSchema = z.lazy(
  () => updateTagRequestViewModelSchema,
) as unknown as ToZod<PutApiV1TagIdMutationRequest>;

export const putApiV1TagIdMutationResponseSchema = z.lazy(
  () => putApiV1TagId202Schema,
) as unknown as ToZod<PutApiV1TagIdMutationResponse>;
